<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        <template v-if="commentData.id">{{ $t('customer.contact.editComment') }}</template>
        <template v-else>{{ $t('customer.contact.addComment') }}</template>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="comment-form" tag="form">
          <div class="form-group">
            <label for="comment-content">
              {{ $t('customer.contact.commentContent') }}:
            </label>

            <validation-provider
              rules="required"
              name="comment-content"
              v-slot="{ errors }">
              <d-textarea
                :value.prop="description"
                :disabled="!isEditable"
                v-model="description"
                :state="errors.length ? 'invalid' : null"
                :rows="5" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="saveInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="saveInProgress || !isEditable"
        @click.prevent="validateForm">
        <div
          v-if="saveInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('ui.save') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'comment-popup',
  props: {
    commentData: {
      default: () => {},
      type: Object
    },
    contactId: {
      required: true,
      type: Number
    },
    userId: {
      required: true,
      type: Number
    }
  },
  computed: {
    isEditable () {
      if (!this.commentData.id) {
        return true;
      }

      return this.commentData.user_id === this.userId;
    }
  },
  data () {
    return {
      description: null,
      user_id: 0,
      saveInProgress: false
    };
  },
  mounted () {
    this.description = this.commentData.description || '';
    this.user_id = this.commentData.user_id || 0;
    this.saveInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('comment-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['comment-form'], this.save);
    },
    save () {
      this.saveInProgress = true;

      let formDataToSend = {
        contact_id: this.contactId,
        description: this.description
      };

      let endpointUrl = '/contacts/comments/store';

      if (this.commentData.id) {
        endpointUrl = '/contacts/comments/update/' + this.commentData.id;
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.$t('customer.contact.saveCommentSuccessTitle'),
        successText: this.$t('customer.contact.saveCommentSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.contact.saveCommentErrorText'),
        successAction: () => {
          this.saveInProgress = false;
          this.$bus.$emit('comments-reload-needed');
          this.cancel();
        },
        failAction: () => {
          this.saveInProgress = false;
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
